import { createContext, useContext, useState } from "react";
import fr from "./fr";
import en from "./en";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("fr");
  const strings = lang === "fr" ? fr : en;

  return (
    <LanguageContext.Provider value={{ lang, setLang, strings }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
